var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 3.9375H21V5.25H0V3.9375H6.5625V1.3125C6.5625 0.588 7.1505 0 7.875 0H13.125C13.8495 0 14.4375 0.588 14.4375 1.3125V3.9375ZM5.1765 14.4375H9.1875V15.75H5.38125L5.89575 19.0562C5.95088 19.4093 6.22913 19.6573 6.54281 19.6573H14.4572C14.7709 19.6573 15.0491 19.4093 15.1043 19.0562L17.0704 6.48769H18.375L16.401 19.2583C16.2488 20.2388 15.4298 20.9698 14.4572 20.9698H6.54281C5.57025 20.9698 4.75125 20.2388 4.599 19.2583L2.61581 6.48769H11.8125V7.80937H4.14356L4.56225 10.5H10.5V11.8125H4.767L5.1765 14.4375ZM7.875 3.9375H13.125V1.3125H7.875V3.9375Z",
    fill: "#E55C42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.1282d19085fa23a8206c1d42c358f563.svg";
export { ForwardRef as ReactComponent };